<div id="wrapper">
  <div id="inputBox">
    <i class="fa fa-arrow-left go-back" (click)="closeAutosuggest()"></i>
    <input autofocus [(ngModel)]="searchStr" placeholder="Search Destination, Hotel or Location" type="text" (keyup)="initiateSearch()" />
    <i (click)="removeSearchStr()" *ngIf="searchStr" class="fa fa-close close"></i>
  </div>
  <div id="wrapperOptions">
    <div class="option" *ngFor="let option of options" (click)="getClickedOption(option)">
      <span innerHTML="{{ option.fullName }}"></span>
      <i class="fa {{typeAndIconMapping[option.type]}}"></i>
    </div>
  </div>
</div>
